import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useNavStore = defineStore('navStore', () => {
  const active = ref('')

  const setTitle = (newTitle) => {
    window.setTitle(newTitle)
  }

  return { active, setTitle }
})
